var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141px",
    height: "39px",
    viewBox: "0 0 141 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B6F4BBB-13D4-45A3-89F1-6EF70A514A3A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.110660592 0.223169492 20.7707062 0.223169492 20.7707062 31.559322 0.110660592 31.559322"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.104601367 0.223169492 41.3363554 0.223169492 41.3363554 31.559322 0.104601367 31.559322"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo/couleur"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.933941, 6.118644)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3989066,18.2139153 C13.4100228,18.2139153 14.9576765,16.0601525 15.0830068,11.7526271 C15.0830068,7.23384746 13.4938952,4.99538983 10.3153531,4.99538983 C7.13681093,4.99538983 5.63125285,7.23384746 5.67334852,11.7526271 C5.84045558,16.0601525 7.38779043,18.2139153 10.3989066,18.2139153 Z M5.67334852,28.7721186 C5.67334852,30.6302542 4.75298405,31.5596441 2.91289294,31.5596441 L0.110660592,31.5596441 L0.110660592,10.1897966 C0.403735763,3.51725424 3.8329385,0.223169492 10.482779,0.223169492 C17.3411845,0.223169492 20.7707062,3.98194915 20.7707062,11.4988644 C20.7707062,19.1007966 17.8434624,23.0286441 11.9462415,23.2395763 C9.18610478,23.2395763 7.09503417,22.0995763 5.67334852,19.7764237 L5.67334852,28.7721186 Z",
    id: "Fill-1",
    fill: "#282828",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.3275626,17.4068983 C53.4946697,10.1849661 57.3005011,6.59525424 64.7029613,6.59525424 L65.4976765,6.59525424 L65.4976765,12.4231017 L63.6154897,12.4231017 C60.52082,12.4231017 58.9734852,14.0703051 58.9734852,17.3222034 L58.9734852,28.9357119 L53.3275626,28.9357119 L53.3275626,17.4068983",
    id: "Fill-4",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0681093,15.3371864 L80.3909339,15.3371864 C80.0564009,12.3809153 78.676492,10.8605932 76.2926651,10.8605932 C73.9082005,10.8605932 72.4861959,12.3809153 72.0681093,15.3371864 Z M76.2926651,29.4429153 C69.6007289,29.231339 66.2547608,25.3041356 66.2547608,17.7022034 C66.2547608,10.1005932 69.6425057,6.29962712 76.3758998,6.25744068 C83.4020501,6.25744068 86.7059226,10.6071525 86.287836,19.3490847 L71.9845558,19.3490847 C72.1934396,22.7700508 73.657221,24.5016271 76.3758998,24.5016271 C77.6722551,24.5016271 78.8853759,23.9528814 79.9725285,22.8966102 C80.4744875,22.3475424 81.1020957,22.0944237 81.8543964,22.0944237 L85.953303,22.0944237 C84.7401822,26.8244576 81.7290661,29.4429153 76.2926651,29.4429153 Z",
    id: "Fill-5",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1374032,10.6071525 L93.5515718,10.6071525 L93.5515718,22.9809831 C93.5515718,23.9103729 94.0953075,24.4169322 95.182779,24.4169322 L96.8975399,24.4169322 L96.8975399,28.6825932 C95.0995444,28.851661 93.1334852,28.851661 91.0424146,28.6400847 C88.951344,28.4291525 87.947426,27.1200847 87.9895216,24.6281864 L87.9895216,0.218016949 L90.8753075,0.218016949 C92.3390888,0.218016949 93.5515718,1.56927119 93.5515718,3.04772881 L93.5515718,6.59525424 L96.8975399,6.59525424 L96.8975399,7.81994915 C96.8975399,9.42464407 95.684738,10.6071525 94.1374032,10.6071525",
    id: "Fill-6",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(98.542141, 6.118644)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7153531,13.9063898 C18.7153531,17.7495424 17.7532118,20.2833051 15.7877904,21.508 C13.8220501,22.648322 11.6471071,23.2395763 9.26328018,23.2395763 C6.96332574,23.2395763 4.91403189,22.6061356 2.99006834,21.3392542 C1.06610478,20.1145593 0.104601367,17.6648475 0.104601367,13.9063898 L0.104601367,0.476610169 L5.66697039,0.476610169 L5.66697039,15.0467119 C5.66697039,17.5382881 6.92154897,18.7633051 9.43070615,18.7633051 C11.9398633,18.7633051 13.1950797,17.5382881 13.1950797,15.0467119 L13.1950797,3.26381356 C13.1529841,1.40567797 14.0312528,0.476610169 15.871344,0.476610169 L18.7153531,0.476610169 L18.7153531,13.9063898",
    id: "Fill-7",
    fill: "#3858A3",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9645558,18.2139153 C33.9753531,18.2139153 35.5230068,16.0601525 35.648656,11.7526271 C35.648656,7.23384746 34.0589066,4.99538983 30.8810023,4.99538983 C27.7024601,4.99538983 26.1965831,7.23384746 26.2383599,11.7526271 C26.405467,16.0601525 27.9534396,18.2139153 30.9645558,18.2139153 Z M26.2383599,28.7721186 C26.2383599,30.6302542 25.3183144,31.5596441 23.4782232,31.5596441 L20.6759909,31.5596441 L20.6759909,10.1897966 C20.9687472,3.51725424 24.3982688,0.223169492 31.0481093,0.223169492 C37.9068337,0.223169492 41.3363554,3.98194915 41.3363554,11.4988644 C41.3363554,19.1007966 38.4087927,23.0286441 32.5118907,23.2395763 C29.751754,23.2395763 27.6606834,22.0995763 26.2383599,19.7764237 L26.2383599,28.7721186 Z",
    id: "Fill-9",
    fill: "#3858A3",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#3858A3",
    points: "21.0392255 10.8953729 21.0392255 6.38689831 14.6410023 12.8475424 19.4080182 17.6613051 14.6410023 22.4750678 21.0392255 28.9357119 21.0392255 24.4272373 26.9514351 24.4272373 26.9514351 10.8953729 21.0392255 10.8953729"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    fill: "#282828",
    points: "12.5250569 22.4750678 17.2920729 17.6613051 6.12715262 6.38689831 6.12715262 10.8953729 0 10.8953729 0 24.4272373 6.12715262 24.4272373 6.12715262 28.9357119 12.5250569 22.4750678"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e92de22ef6f67eefc5f8adc7894be742.svg";
export { ForwardRef as ReactComponent };